import UserServiceClient from 'app/clients/userService'

export const fetchCandidatesAPI = (data, signal) => {
  console.log('Signal in fetchCandidatesAPI:', signal)
  console.log('Signal aborted:', signal.aborted)
  return UserServiceClient.post(`/get-candidates`, data, { signal }) // Pass signal inside a config object
}
